import APIClient from '@/shared/http/clients/api'

const resourceName = 'despesatipo'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAllDiverse = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/diversos`, data, config)
const GetAllRefund = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/reembolso`, data, config)
const ReembolsoNotCred = (motivoVenda, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/reembolsoNotCred/${motivoVenda}`, data, config)
const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const GetByCodigo = (codigo, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/codigo/${codigo}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, config)

const ExpenseTyeRepository = {
  GetAll,
  GetAllPaging,
  GetAllDiverse,
  GetAllRefund,
  GetById,
  GetByCodigo,
  Create,
  Update,
  Delete,
  ReembolsoNotCred
}

export default ExpenseTyeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/expensetype.js